import React from 'react';
import Image from 'gatsby-image';

import { Link, useStaticQuery, graphql } from 'gatsby';

const Footer = () => {
  const result = useStaticQuery(
    graphql`
      {
        file(relativePath: { eq: "LogoFondimex.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  return (
    <footer>
      <div className="mb-4 py-20 px-10 text-center border-b-2 border-gray-400">
        <Link to="/">
          <Image
            className="w-64 mx-auto inline-block"
            fluid={result.file.childImageSharp.fluid}
            alt="Fondeo digital mexicano"
          />
        </Link>
      </div>
      <p className="text-gray-700 py-5 text-center">
        2019. Fondimex. Todos los derechos reservados.
      </p>
    </footer>
  );
};

export default Footer;
